import { useNavigation } from '@react-navigation/native';
import { Button, Headline3, theme } from 'aimo-ui';
import { InfoIcon } from 'components/icons/InfoIcon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { UnifiedPermit } from 'types/generatedSchemaTypes';
import { RootNavProps } from 'types/navigation';
import {
  handlePermitNavigation,
  isItemAccessPermit,
  isPermitMissingVehicle,
  showLicensePlate,
} from 'utils/permitUtils';

interface RedeemPermitButtonProps {
  permit: UnifiedPermit;
}

const RedeemPermitButton: React.FC<RedeemPermitButtonProps> = ({ permit }) => {
  const { t } = useTranslation();
  const { navigate } = useNavigation<RootNavProps>();

  const getButtonText = () => {
    if (!isItemAccessPermit(permit)) {
      return t('permit.access.redeemPermit');
    }

    if (
      showLicensePlate(permit) &&
      isPermitMissingVehicle(permit?.registrationPlates)
    ) {
      return t('permit.access.addVehicle');
    }

    return t('permit.access.redeemPermit');
  };

  return (
    <StyledWrapper mt={10}>
      <Button
        testID={'redeem-permit-button'}
        buttonType="secondary"
        size="l"
        iconComponent={InfoIcon}
        onPress={() => handlePermitNavigation(permit, navigate)}>
        <Headline3 color={theme.colors.white}>{getButtonText()}</Headline3>
      </Button>
    </StyledWrapper>
  );
};

export default RedeemPermitButton;
